/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, NotificationEmailPreferencesControllerGetNotificationEmailPreferencesPathParams, NotificationEmailPreferencesControllerGetNotificationEmailPreferences400, NotificationEmailPreferencesControllerGetNotificationEmailPreferences401, NotificationEmailPreferencesControllerGetNotificationEmailPreferences403, NotificationEmailPreferencesControllerGetNotificationEmailPreferences404 } from "../../models/notificationEmailPreferencesController/NotificationEmailPreferencesControllerGetNotificationEmailPreferences";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationEmailPreferencesControllerGetNotificationEmailPreferences } from "../../clients/notification-email-preferencesService/notificationEmailPreferencesControllerGetNotificationEmailPreferences";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey = (userId: NotificationEmailPreferencesControllerGetNotificationEmailPreferencesPathParams["userId"]) => [{
  url: '/api/v1/notification-email-preferences/:userId',
  params: {
    userId: userId
  }
}] as const;
export type NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey = ReturnType<typeof notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey>;
export function notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryOptions(userId: NotificationEmailPreferencesControllerGetNotificationEmailPreferencesPathParams["userId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey(userId);
  return queryOptions<NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, ResponseErrorConfig<NotificationEmailPreferencesControllerGetNotificationEmailPreferences400 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences401 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences403 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences404>, NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, typeof queryKey>({
    enabled: !!userId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationEmailPreferencesControllerGetNotificationEmailPreferences(userId, config);
    }
  });
}

/**
 * @description Returns every user-configurable event with its catalog copy, its default, and the resolved delivery mode. Self-only. Renders the settings screen without the front end knowing which events exist.
 * @summary Get per-event notification email preferences
 * {@link /api/v1/notification-email-preferences/:userId}
 */
export function useNotificationEmailPreferencesControllerGetNotificationEmailPreferences<TData = NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, TQueryData = NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, TQueryKey extends QueryKey = NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey>(userId: NotificationEmailPreferencesControllerGetNotificationEmailPreferencesPathParams["userId"], options: {
  query?: Partial<QueryObserverOptions<NotificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryResponse, ResponseErrorConfig<NotificationEmailPreferencesControllerGetNotificationEmailPreferences400 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences401 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences403 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryKey(userId);
  const query = useQuery({
    ...notificationEmailPreferencesControllerGetNotificationEmailPreferencesQueryOptions(userId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationEmailPreferencesControllerGetNotificationEmailPreferences400 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences401 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences403 | NotificationEmailPreferencesControllerGetNotificationEmailPreferences404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}